import { format } from "date-fns";

export const transformCardExpirationDate = (cardExpiryDate: string) => {
  const cardDate = new Date(cardExpiryDate);
  const formattedCardExpiryDate = format(cardDate, "MM/yyyy");

  return formattedCardExpiryDate;
};
